import { useContext, useState } from "react";
import { t } from "i18next";

import { styled } from "@mui/material/styles";
import { WaiverRoles } from "../../../../../../types/enums";

import { RootContext } from "../../../../../../context/RootContext";
import CustomModal from "../../../../../../components/common/CustomModal";
import ReRequestWaiverConfirmation from "./ReRequestWaiverConfirmation";
import WaiverList from "./WaiversList";
// import PreviewIcon from "../../../../../../assets/PreviewIcon.svg";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function RequestWaiver(props: any) {
  const {
    setIsRequestPricingWaiver,
    requestedWaivers,
    isLoading,
  } = props;
  const { userPermissions } = useContext(RootContext) ?? {};
  const isRequestor = !userPermissions?.includes(WaiverRoles.PRICING_WAIVER_APPROVER);
  const [showConfirmationPopup, setshowConfirmationPopup] = useState(false);
  const [resetWaiverData, setResetWaiverData] = useState(false);

  const handleRequestWaiverClick = () => {
    const isWaiverAlreadyRequested = requestedWaivers.some((waiver: any) => waiver?.data?.waiverStatus === "Requested");
    if (!isWaiverAlreadyRequested) {
      setIsRequestPricingWaiver(true);
    } else {
      setshowConfirmationPopup(true);
    }
  };

  const onConfirmationPopupClose = () => {
    setshowConfirmationPopup(false);
  };

  // A pending exception already exists — proceeding here doesn't delete
  // anything (the waiver service has no delete endpoint): the new numbers
  // are recorded as a fresh "requested" response on that same waiver when
  // the form is submitted (see RequestWaiverWrapper.handleWaiverRequest),
  // so the prior ask is preserved in the waiver's own audit trail rather
  // than being discarded.
  const confirmReRequestWaiver = () => {
    setIsRequestPricingWaiver(true);
    setshowConfirmationPopup(false);
    setResetWaiverData(true);
  };

  return (
    <>
      {showConfirmationPopup && ( 
        <CustomModal
          open={showConfirmationPopup}
          handleClose={onConfirmationPopupClose}
          className={"saveApplication"}
        >
          <ReRequestWaiverConfirmation
            onConfirm={confirmReRequestWaiver}
            onClose={onConfirmationPopupClose}
            isLoading={isLoading}
          />
        </CustomModal>
      )}
      <WaiverList
        {...props}
        t={t}
        isRequestor={isRequestor}
        handleRequestWaiverClick={handleRequestWaiverClick}
        resetWaiverData={resetWaiverData}
        setResetWaiverData={setResetWaiverData}
      />
      <></>
    </>
  );
}
